// extracted by mini-css-extract-plugin
export default {"spinner":"PartialDisruptionPage_spinner__Vh6xi"};